import { render } from "./NotaFiscalFrete.vue?vue&type=template&id=f023818e&scoped=true&ts=true"
import script from "./NotaFiscalFrete.vue?vue&type=script&lang=ts"
export * from "./NotaFiscalFrete.vue?vue&type=script&lang=ts"

import "./NotaFiscalFrete.vue?vue&type=style&index=0&id=f023818e&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f023818e"]])

export default __exports__